class GraphicSearch {
	constructor() {
		this._http = getAjaxObject();
		this._http.onload = this.append.bind(this);
		this._page = 0;

		this._onSelect = null;

		this._dialog = Dialog.Modal('graphic-search', _("Graphic Search"), X_LARGE, null, [
			this._results = UI.div(),
			this._getMore = UI.div('text-center', [
				UI.btn('', _("LOAD MORE"), {
					'click': this.loadMore.bind(this)
				})
			])
		]);
		this._dialog.head = UI.div('flex items-center gap-3', [
			UI.div('flex-1', [
				this._searchText = UI.text(null, {
					'keyup': this.type.bind(this),
					'paste': this.paste.bind(this)
				}, {
					'placeholder': _("Enter keywords for search"),
				})
			]),
			UI.div('flex-0', [
				this._uploadBtn = UI.btn('', _("UPLOAD"), {
					'click': this.upload.bind(this)
				}, {
					'data-tip': _("Upload your own graphic")
				})
			])
		]);
		this._dialog.foot = UI.btn('', _("NO GRAPHIC"), {
			'click': () => this.select(0)
		});
	}

	start(initialText, onSelect) {
		this._onSelect = onSelect;
		this._searchText.value = initialText || '';
		this._dialog.open();
		this.clear();
		this.search(initialText);
		this._searchText.select();
	}

	type() {
		this.clear();
		this.search(this._searchText.value);
	}

	paste(ev) {
		if (ev.clipboardData.getData('text').length == 0) return;
		this.clear();
		this.search(ev.clipboardData.getData('text'));
	}

	loadMore(){
		this._page++;
		this.search(this._searchText.value);
	}

	clear() {
		this._page = 0;
		this._results.innerHTML = '';
	}

	search(text) {
		if(this._http.readyState < 4) this._http.abort();
		let params = new URLSearchParams();
		params.append('s', text);
		params.append('p', this._page);
		
		this._http.open('GET', '/api/graphics?' + params.toString());
		this._http.send();
	}

	append() {
		let data = JSON.parse(this._http.responseText);
		if (Array.isArray(data)) {
			this._getMore.style.display = data.length < 12 ? 'none' : 'block';
			data.forEach(id => {
				this._results.appendChild(GraphicCard.fromId(id, this));
			}, this); 
		}
	}

	select(id) {
		if (id === null) return;
		if (this._onSelect !== null) {
			this._onSelect(id);
		}
		this._onSelect = null;
		this._dialog.close();
	}

	upload() {
		gUpload.open(this.select.bind(this), this._searchText.value);
	}
}